import messageResource from '../../../messageResource'
import {ColumnsConfig} from '../../overtimeReport/ColumnsConfig'
import ListSelector from '../../../controls/ListSelector'

export default class OvertimeReportColumnsFormatSelector {
    init(columnsConfig, onConfigChanged) {
        this.columnsConfigSelector = new ListSelector({
            renderTo: "columnsTypeSelector",
            menuCls: "columnsFormatMenu"
        })

        this.columnsConfigSelector.addItems([
            {
                text: messageResource.getEscapedMessage("report.overtime.columns_config.time_balance_and_overtime"),
                value: ColumnsConfig.TIME_BALANCE_AND_OVERTIME
            },
            {
                text: messageResource.getEscapedMessage("report.overtime.columns_config.time_balance_only"),
                value: ColumnsConfig.TIME_BALANCE_ONLY
            },
            {
                text: messageResource.getEscapedMessage("report.overtime.columns_config.overtime_only"),
                value: ColumnsConfig.OVERTIME_ONLY
            }
        ])

        this.columnsConfigSelector.on("change", onConfigChanged)

        this.columnsConfigSelector.setActiveItemByValue(columnsConfig, true)

        return this.columnsConfigSelector
    };
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/overtime/OvertimeReportColumnsFormatSelector.js